<div class="logged-in-view h-full overflow-y-auto">
    <div class="w-full flex justify-between items-center mb-10">
        <div class="flex flex-col gap-2">
            <h1 class="text-app-primary-10 m-0">App-Administration</h1>
            <p class="text-app-primary-10">Verwalten Sie Apotheken, Praxen, Ärzte und Systemvorlagen.</p>
        </div>
    </div>

    <!-- Tabs Section -->
    <mat-tab-group dynamicHeight class="w-full">
        <mat-tab label="Vorlagen">
            <app-administration-templates></app-administration-templates>
        </mat-tab>
        <mat-tab label="Apotheken">
            <app-pharmacy-administration></app-pharmacy-administration>
        </mat-tab>
        <mat-tab label="Praxen">
            <app-practice-administration></app-practice-administration>
        </mat-tab>
        <mat-tab label="Ärzte">
            <app-doctor-administration></app-doctor-administration>
        </mat-tab>
        <mat-tab label="Archiv">
            <app-administration-archive></app-administration-archive>
        </mat-tab>
    </mat-tab-group>
</div>
